(function () {
'use strict';

angular
    .module('riskSelfAssessmentAssessRoutes', [
        'riskSelfAssessmentAssessControllers'
    ])
    .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider
             .state('riskSelfAssessmentAssess', {
                 url: '/RiskSelfAssessment/User@{ItemPersonID:int}',
                 resolve: {
                     authenticatedAssessorID: ['$stateParams', 'authenticatedUser', function ($stateParams, authenticatedUser) {
                         if (authenticatedUser.ItemPersonID === $stateParams.ItemPersonID) {
                             return null;
                         } 
                         return $stateParams.ItemPersonID;
                     }],
                     govProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveRiskSelfAssessments();
                     }],
                     isAssessor: ['commonRiskSelfAssessmentService', 'authenticatedAssessorID', function (service, authenticatedAssessorID) {
                         return service.isAssessor(authenticatedAssessorID);
                     }],
                     criterias: ['commonRiskSelfAssessmentService', function (service) {
                         return service.getAllCriterias();
                     }],
                     assessmentQuestions: ['commonRiskSelfAssessmentService', 'authenticatedAssessorID', function (service, authenticatedAssessorID) {
                         return service.getAssessmentQuestions(authenticatedAssessorID);
                     }]
                 },
                 templateUrl: require('./assess.tpl.html'),
                 controller: 'RiskSelfAssessmentAssessController',
             })

            .state('riskSelfAssessmentAssess.welcome', {
                url: '/Welcome',
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        templateUrl: require('./assessWelcome.tpl.html'),
                        controller: 'RiskSelfAssessmentAssessWelcomeController'
                    }
                }
            })

            .state('riskSelfAssessmentAssess.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        templateUrl: require('./assessNoActiveProcess.tpl.html'),
                        controller: 'RiskSelfAssessmentAssessController'
                    }
                }
            })

            .state('riskSelfAssessmentAssess.noRisksToAssess', {
                url: '/NoRisksToAssess',
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        templateUrl: require('./assessNoRisksToAssess.tpl.html'),
                        controller: 'RiskSelfAssessmentAssessController'
                    }
                }
            })

            .state('riskSelfAssessmentAssess.summary', {
                url: '/Summary',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        resolve: {
                            risksToAssess: ['authenticatedAssessorID', 'riskSelfAssessmentAssessService', function (authenticatedAssessorID, service) {
                                return service.getRisksToAssess(authenticatedAssessorID);
                            }]
                        },
                        templateUrl: require('./assessSummary.tpl.html'),
                        controller: 'RiskSelfAssessmentAssessSummaryController'
                    }
                }
            })

            .state('riskSelfAssessmentAssess.preliminaryQuestions', {
                url: '/PreliminaryQuestions',
                resolve: {
                    risksToAssess: ['authenticatedAssessorID', 'riskSelfAssessmentAssessService', function (authenticatedAssessorID, service) {
                        return service.getRisksToAssess(authenticatedAssessorID);
                    }]
                },
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        templateUrl: require('./assessPreliminaryQuestions.tpl.html'),
                        controller: 'RiskSelfAssessmentPreliminaryQuestionsController'
                    }
                }
            })

            .state('riskSelfAssessmentAssess.assessor', {
                url: '/Risk',
                abstract: false,
                resolve: {
                    risksToAssess: ['authenticatedAssessorID', 'riskSelfAssessmentAssessService', function (authenticatedAssessorID, service) {
                        return service.getRisksToAssess(authenticatedAssessorID);
                    }]
                },
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        template: '',
                        controller: 'RiskSelfAssessmentAssessRiskController'
                    }
                }
            })


            .state('riskSelfAssessmentAssess.assessor.riskToAssess', {
                url: '/{RiskID:int}/Assess',
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        templateUrl: require('./assessRisk.tpl.html'),
                        controller: 'RiskSelfAssessmentAssessRiskController'
                    }
                }
            })

            .state('riskSelfAssessmentAssess.finalQuestions', {
                url: '/FinalQuestions',
                resolve: {
                    risksToAssess: ['authenticatedAssessorID', 'riskSelfAssessmentAssessService', function (authenticatedAssessorID, service) {
                        return service.getRisksToAssess(authenticatedAssessorID);
                    }]
                },
                views: {
                    'mainContent@riskSelfAssessmentAssess': {
                        templateUrl: require('./assessFinalQuestions.tpl.html'),
                        controller: 'RiskSelfAssessmentFinalQuestionsController'
                    }
                }
            });

        // History Context
        historyCtxtServiceProvider.setCtxtState('riskSelfAssessmentAssess.summary',
            '/app/Main/riskSelfAssessment/assess/GOVHistoryCtxtDirective-riskSelfAssessmentSummary.tpl.html'
        );
    }
})();
